import { Injectable } from '@angular/core';

/**
 * @title Notification Service
 * @since 1.0.0
 * 
 * @description This service is responsible for handling browser notifications.
 * It provides methods to request notification permissions and show notifications.
 * 
 */
@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    /**
     * Requests permission to display notifications to the user.
     * If granted, the application can show notifications.
     * @since 1.0.0
     * @returns {void}
     */
    requestPermission(): void {
        if ('Notification' in window) {
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    console.log('Notification permission granted.');
                } else {
                    console.log('Notification permission denied.');
                }
            });
        }
    }

    /**
     * Displays a notification with the specified title and options.
     * @since 1.0.0
     * @param {string} title - The title of the notification.
     * @param {NotificationOptions} [options] - Additional options for the notification.
     * @returns {void}
     */
    showNotification(title: string, options?: NotificationOptions): void {
        if (Notification.permission === 'granted') {
            navigator.serviceWorker.getRegistration().then(registration => {
                if (registration) {
                    registration.showNotification(title, options);
                }
            });
        }
    }
}